<template lang="pug">
div.body-fpw
  div.modal-header
    span.fpw-modal-title QUÊN MẬT KHẨU
    span.fpw-modal-btn-close.material-icons(@click="$emit('close')") close
  div.modal-body
    p.fpw-content Nhập email đã đăng ký của bạn để nhận lại mật khẩu mới qua email:
    .row
      .col-md-12
        .alert.alert-danger(v-if='error') {{error}}
    .row
      .col-md-12.form-group.fpw-email
        input#email.form-control(type="email" name="email" placeholder="Nhập email" required autofocus v-model="email")
  div.modal-footer.fpw-custom-footer
    div.row
      div.col-md-6.col-12
        div.text-right
          a.fpw-btn-continue.btn(@click='validateForgot()') Gửi yêu cầu
      div.col-md-6.col-12
        div.text-left
          a.fpw-btn-back.btn(@click="$emit('close')") Hủy
</template>
<script>
import firebase from 'firebase'
import MdNotification from '@/core/components/mdNotification'
export default {
  components: {
    MdNotification
  },
  data () {
    return {
      email: '',
      error: null
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    validateForgot() {
      if (this.email.length > 0) {
        var auth = firebase.auth()
        var emailAddress = this.email
        auth.sendPasswordResetEmail(emailAddress).then(() => {
          // console.log('Email sent')
          // this.showNotification('Mật khẩu mới đã gửi về Email', 'success', 'top', 'right', 2000)
          this.showNotification('Mật khẩu mới được gửi về Email nếu Email này đã từng được đăng ký', 'success', 'top', 'right', 2000)
          this.$emit('close')
        }).catch((error) => {
          if (error.code === 'auth/invalid-email') {
            this.error = 'Email không đúng format'
          } else if (error.code === 'auth/user-not-found') {
            // this.error = 'Email không tồn tại trong hệ thống'
            this.error = 'Mật khẩu mới được gửi về Email nếu Email này đã từng được đăng ký'
          } else {
            this.error = error
            console.error(error)
          }
        })
      } else {
        this.error = 'Vui lòng nhập Email'
      }
    }
  }
}
</script>
<style lang="scss">
:root {
  // Color 
  --color-background-button: #FFD311;
}
.body-fpw {
  margin-left: 20px;
  margin-right: 20px;
  background-color: white;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 10px;
  font-family: 'adobe-clean', sans-serif;
  .fpw-modal-title {
    float: left;
    font-size: 17px;
  }
  .fpw-modal-btn-close {
    float: right;
    &:hover {
      cursor: pointer;
    }
  }
  .fpw-body-title {
    color: var(--color-type-selected);
    margin-bottom: 0;
    padding-bottom: 3px;
  }
  .fpw-content {
    margin-bottom: 15px;
    font-size: 15px;
  }
  .fpw-email {
    margin-top: 0px; 
    margin-bottom: 0px; 
  }
  .fpw-btn-continue {
    background: var(--color-background-button);
    color:black;
    text-transform: none;
    font-size: 13px;
    // font: 14px/17px Proxima Nova;
    border: 1px solid #FFD311;
    border-radius: 5px;
    // box-shadow: 0px 0px 0px;
    width: 160px;
    margin-top: 0 !important;
    margin-bottom: 20px;
  }
  .fpw-btn-back {
    background: white;
    color: black;
    text-transform: none;
    font-size: 13px;
    // font: 14px/17px Proxima Nova;
    border: 1px solid #FFD311;
    border-radius: 5px;
    // box-shadow: 0px 0px 0px;
    width: 160px;
    margin-top: 0 !important;
  }
  .fpw-custom-footer {
    padding: 0;
    border: 0;
  }

// cellphones
@media (max-width: 414px) {
  .fpw-email {
    margin-bottom: -10px
  }
  .fpw-btn-continue {
    float: left;
    margin-left: 40px;
    width: 115px;
    padding: 12px;
    margin-top: 0px;
  }
  .fpw-btn-back {
    float: right;
    margin-right: 40px;
    width: 115px;
    margin-top: 0px;
  }
}
}
</style>



// WEBPACK FOOTER //
// ForgotPassword.vue?46800958